import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

const $http = new APIManager();

const Api = {
  /* [GET] 통계데이터 조회 */
  getStatistics: (type, q = {}) =>
    $http.get(parameterToPath(APIConstant.GET_STATISTICS, { type }), q),

  /* [GET] 날짜별 총 합계 조회 */
  getStatisticsSummary: async (type, params = {}) => {
    try {
      const res = await $http.get(
        parameterToPath(APIConstant.GET_STATISTICS_SUMMARY, { type }),
        params
      );

      return res;
    } catch (e) {
      throw e;
    }
  },

  getForeignKeyCheck: async (params = {}) => {
    try {
      const res = await $http.get(
        APIConstant.GET_STATISTICS_FOREIGN_CHECK,
        params
      );

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
